import React from 'react'
import AboutSection from './AboutSection'
import AboutSecondSection from './AboutSecondSection'

function About() {
    return (
        <div>
            <AboutSection />
            <AboutSecondSection />
        </div>
    )
}

export default About
